'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

exports.default = Image;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Image Component.
 * @param {Object} props The new component properties.
 * @returns {ReactElement} HTML markup for the component
 */
function Image(props) {
    var _props$source = props.source,
        source = _props$source === undefined ? '' : _props$source,
        _props$altText = props.altText,
        altText = _props$altText === undefined ? '' : _props$altText,
        _props$width = props.width,
        width = _props$width === undefined ? '' : _props$width,
        _props$height = props.height,
        height = _props$height === undefined ? '' : _props$height,
        _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id;


    return (0, _jsx3.default)('img', {
        src: source,
        alt: altText,
        width: width,
        height: height,
        className: className,
        id: id
    });
}
//# sourceMappingURL=Image.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/image/Image.js
// module id = 559
// module chunks = 0